// extracted by mini-css-extract-plugin
module.exports = {"blockCrossedOutText":"crossed-out-text_blockCrossedOutText__1qjjv","line":"crossed-out-text_line__35zeE"};